export default __webpack_public_path__ + "545480979ec2f7964918abf615ad678e.png";